import formatDate from '@anm/helpers/date/formatDate';

const getFirstDayOfNextMonth = () => {
  const date = new Date();
  const firstDayOfNextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1, 0);

  return formatDate(firstDayOfNextMonth.toString(), { isHours: false });
};

export default getFirstDayOfNextMonth;
